import React from 'react';
import I18n from 'i18n-js';
import { Location } from 'history';

import { SquareCard } from '@reverbdotcom/commons/src/components/square_card';
import { RCButton, RCTooltip } from '@reverbdotcom/cadence/components';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';

import { getFinishesTooltipText } from '../../CardNudges';
import { SellCardData } from '@reverbdotcom/commons/src/gql/graphql';
import URLHelpers from '../../shared/url_helpers';

export const COMPONENT_NAME = 'PriceGuideToolCard';

interface IProps {
  csp: SellCardData.Fragment;
  index: number;
  location?: Location;
}

export function Finishes({ csp }) {
  return (
    <div className="price-guide-tool-card__tooltip">
      <RCTooltip text={getFinishesTooltipText(csp.finishes)} stopPropagation>
        {I18n.t('discovery.priceGuideTool.index.card.multipleFinishes')}
      </RCTooltip>
    </div>
  );
}

export default function PriceGuideToolCard({ csp, index, location }: IProps) {
  const query = location?.query;

  return (
    <SquareCard
      csp={csp}
      key={csp.id}
      position={index}
      destinationPath={URLHelpers.priceGuideShowPath(csp.slug, query)}
      hideFinishes
      clickEvent={{
        eventName: MParticleEventName.ClickedGetPriceEstimateButtonInsidePriceGuideToolCard,
        componentName: COMPONENT_NAME,
        cspId: csp.id,
        cspSlug: csp.slug,
        entityId: csp.slug,
        entityType: 'url',
      }}
    >
      <>
        {
          csp.finishes?.length > 1 && (
            <Finishes csp={csp} />
          )
        }

        <div className="mt-2">
          <RCButton
            fullWidth
            variant="filled"
          >
            {I18n.t('discovery.priceGuideTool.index.card.button')}
          </RCButton>
        </div>
      </>
    </SquareCard>
  );
}
